import React from "react";

import { useTranslate } from "localization";
import { Filter } from "ui/forms";
import { Option } from "ui/forms/Filter/Menu";

import useFilterParam from "./useFilterParam";

interface StatusProps {
  options: Option[];
  disabled?: boolean;
}

const TaskListStatus: React.FC<StatusProps> = ({
  options,
  disabled = false,
}) => {
  const { translate } = useTranslate();
  const title = translate("status");

  const [selected, setSelected] = useFilterParam("status", options, {
    defaultToFirst: false,
  });

  const selectedLabel =
    options.find((o) => o.value === selected)?.label ?? title;

  return (
    <Filter
      items={{ options }}
      title={title}
      label={selectedLabel}
      selected={!!selected}
      disabled={options.length === 0 || disabled}
      onChange={setSelected}
      value={selected ?? ""}
      showReset={true}
      showApply={true}
      searchable={true}
      translate={translate}
    />
  );
};

export default TaskListStatus;
